import axios from "axios";
import {detailServicesPath} from "../../../Constants";

const detailControllerRestUrl = detailServicesPath + '/organizations'

export default class QuarterControllerServiceOrganization {
    static async add(detailId, sideStartPointId, data) {
        return await axios.post(`${detailControllerRestUrl}/quarters?detailId=${detailId}&sideStartPointId=${sideStartPointId}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(quarterId) {
        return await axios.delete(`${detailControllerRestUrl}/quarters/${quarterId}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async put(quarterId, sideStartPointId, data) {
        return await axios.put(`${detailControllerRestUrl}/quarters/${quarterId}?sideStartPointId=${sideStartPointId}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}